
    import React from 'react';
    import { usePartySurveyCreate, usePartySurveySoftDelete,usePartySurveyMultipleSoftDelete, usePartySurveyUpdate } from '../../queries/PartySurvey.queries';
    import PartySurvey from './PartySurvey';
    
    const PartySurveyContainer = () => {
    
      const {mutate:addRecord} = usePartySurveyCreate();
      const {mutate:editRecord} = usePartySurveyUpdate();
      const {mutate:deleteRecord} = usePartySurveySoftDelete();
      const {mutate:deleteRecords} = usePartySurveyMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <PartySurvey 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default PartySurveyContainer;
    